import DiscordIcon from '@/components/icons/DiscordIcon';
import {
    BookOpen,
    Briefcase,
    Calendar,
    FileText,
    Globe,
    GraduationCap,
    HeadphonesIcon,
    HelpCircle,
    Home,
    type LucideIcon,
    Layers,
    Mail,
    MessageCircle,
    Mic,
    Send,
    Star,
    Users,
    Video,
    Wrench,
    Zap,
} from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
    BookOpen,
    Briefcase,
    Calendar,
    Discord: DiscordIcon as unknown as LucideIcon,
    Home,
    FileText,
    Globe,
    GraduationCap,
    HeadphonesIcon,
    HelpCircle,
    Layers,
    Mail,
    MessageCircle,
    Mic,
    Send,
    Star,
    Users,
    Video,
    Wrench,
    Zap,
};

export const getIconByName = (name: string): LucideIcon | null => {
    return iconMap[name] ?? null;
};
